import React from 'react'
import { Link } from 'react-router-dom'

interface Column {
  header: string
  accessor: string
  className?: string
}

interface ListTableProps {
  columns: Column[]
  data: any[]
  rowActions?: (item: any) => React.ReactNode
  editPathPrefix: string
}

export const ListTable: React.FC<ListTableProps> = ({ columns, data, rowActions, editPathPrefix }) => (
  <div className="overflow-x-auto">
    <table className="w-full">
      <thead>
        <tr className="bg-gray-50 border-b border-gray-200">
          {columns.map((column) => (
            <th
              key={column.accessor}
              className={`text-left text-gray-700 font-semibold py-2 px-4 text-sm ${column.className || ''}`}
            >
              {column.header.toUpperCase()}
            </th>
          ))}
          {rowActions && (
            <th className="py-2 px-4 text-sm w-32"></th>
          )}
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr
            key={index}
            className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
          >
            {columns.map((column, colIndex) => (
              <td key={column.accessor} className="py-3 px-4">
                {colIndex === 0 ? (
                  <Link
                    to={`${editPathPrefix}/${item.id}`}
                    className="text-panagora-deep-blue hover:underline"
                  >
                    {item[column.accessor]}
                  </Link>
                ) : (
                  <span className="text-panagora-slate-gray">
                    {item[column.accessor]}
                  </span>
                )}
              </td>
            ))}
            {rowActions && (
              <td className="py-3 px-4 w-32">
                {rowActions(item)}
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)
